import { useRef, useState } from 'react';
import { FormProvider, useForm } from 'react-hook-form';
import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { updateNoteAction } from '../../../redux/actions/notesActions';
import { notBlankValidation } from '../../../utils/validations';
import TiptapEditor from '../../notes/TiptapEditor';
import Button from '../../shared/buttons/Button';
import Container from '../../shared/container/Container';
import Input from '../../shared/input/Input';
import FormToggle from '../../shared/toggle/FormToggle';
import DeleteNoteModal from '../modal/DeleteNoteModal';

const NoteForm = ({ note, readOnly }) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [saving, setSaving] = useState(false);
  const [showDeleteNoteModal, setShowDeleteNoteModal] = useState(false);

  const editorDataRef = useRef({ json: note.content, text: note.plainText || '' });

  const methods = useForm({
    defaultValues: {
      title: note.title,
      isPublic: note.isPublic,
    },
  });

  const handleEditorUpdate = ({ json, text }) => {
    editorDataRef.current = { json, text };
  };

  const handleDeleteNoteModalSubmit = async () => {
    setShowDeleteNoteModal(false);
    navigate(`/notes`);
  };

  const onSubmit = async (data) => {
    setSaving(true);
    await dispatch(
      updateNoteAction(note.id, {
        title: data.title,
        content: editorDataRef.current.json,
        plainText: editorDataRef.current.text,
        isPublic: data.isPublic || false,
      }),
    );
    setSaving(false);
    navigate(`/notes`);
  };

  return (
    <Container>
      {showDeleteNoteModal && (
        <DeleteNoteModal
          note={note}
          onModalSubmit={() => handleDeleteNoteModalSubmit()}
          onModalClose={() => setShowDeleteNoteModal(false)}
        />
      )}
      <FormProvider {...methods}>
        <form
          id="note-content-form"
          noValidate
          className="flex flex-col gap-4"
          onSubmit={methods.handleSubmit(onSubmit)}
        >
          <Input
            label="Назва"
            type="input"
            name="title"
            disabled={readOnly || saving}
            placeholder={'Введіть назву нотатки'}
            validation={notBlankValidation}
          />
          <div className="relative w-full">
            <label className="input-label">Зміст</label>
            <TiptapEditor content={note.content} onUpdate={handleEditorUpdate} editable={!readOnly && !saving} />
          </div>
          <FormToggle name="isPublic" label="Публічна" disabled={readOnly || saving} />
          {!readOnly && (
            <div className="flex justify-end gap-4">
              <Button variant="download" onClick={() => setShowDeleteNoteModal(true)} disabled={saving}>
                Видалити
              </Button>
              <Button type="submit" variant="primary" formId="note-content-form" disabled={saving}>
                Зберегти
              </Button>
            </div>
          )}
        </form>
      </FormProvider>
    </Container>
  );
};

export default NoteForm;
